module.exports = __webpack_public_path__ + "img/sugar.1d049b4e.jpg";